export enum VersionManagerActions {
  None = 'None',
  ReloadWorkflow = 'ReloadWorkflow',
  SaveAndOpenWorkflow = 'SaveAndOpenWorkflow',
}
